// In App navigatio component to create modals

import { Injectable } from '@angular/core';
import { AlertController, MenuController, ModalController, Platform, PopoverController } from '@ionic/angular';
import { checkRoutesName, stringToClass } from './factory';
import { PopoverClass } from 'src/app/popovers/popover-factory';
import { NavigationOptions } from 'src/app/interfaces/navigation-interface'
import { ActivatedRoute, Router } from '@angular/router';
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";

import type { PopoverSize } from '@ionic/core';
import { EventsService } from 'src/app/services/event/event.service';
import { Location } from "@angular/common";
import { ConfigService } from 'src/app/services/config/config.service';

@Injectable({
	providedIn: 'root',
})

export class Navigator {

	public activePage: any = '';
	public activeModals: HTMLIonModalElement[] = [];
	public activePopovers: HTMLIonPopoverElement[] = [];
	public currentTab: string;
	public modal: any;
	public isMobileApp: boolean = false;
	public activeLobbyTabName: string = '';
	public storeWPLinkCode: string = '';
	public currentPage = null;
	private modalStack: any[] = [];
	public storeCasinoKeywordRoute: string = '';

	constructor(
		public alertController: AlertController,
		public events: EventsService,
		public menuCtrl: MenuController,
		public modalCtrl: ModalController,
		public platform: Platform,
		public popoverController: PopoverController,
		public config: ConfigService,
		public router: Router,
		public activateRouter: ActivatedRoute,
		public screenOrientation: ScreenOrientation,
		public location: Location,
		private readonly menuController: MenuController
	) {

	}

	/*
	passing pagename, options and params to pass data from one page to another
	to get the params data in page use it like this.....
	any variable defined inside params object can be accessed using @Input()
	See DepositSuccessFailureComponent for Example
	*/

	public navigateTo(pageName, options?: any, params?: any, menuSide?) {
		setTimeout(() => this.currentPage = null, 1000);

		if (this.currentPage === pageName) {
			console.info("Page already opened")
			return
		}
		this.currentPage = pageName;

		const page = stringToClass(pageName);
		const pageParams = (typeof params !== "undefined") ? params : "";
		const ModalOptions: NavigationOptions = this.getOptions(options);

		//get the modal route with friendly path
		const modalRoute = checkRoutesName(pageName);

		if (this.activeModals.length && !ModalOptions.multipleModals) {
			this.dismissAll();
		}
		this.openModal(page, pageName, ModalOptions, pageParams, menuSide).then(() => this.sendHistoryEvent(modalRoute));
	}

	async openModal(page: any, pageName, ModalOptions?: any, params?: any, menuSide?) {

		const backdropDismissFlag: boolean = (typeof ModalOptions.backdropDismiss === "undefined") ? false : ModalOptions.backdropDismiss;
		const customClass: string = (typeof ModalOptions.customModalClass === "undefined") ? 'custom-modal-class' : ModalOptions.customModalClass;

		const modal = await this.modalCtrl.create({
			component: page,
			componentProps: params,
			cssClass: customClass,
			animated: true,
			backdropDismiss: backdropDismissFlag,
		});
		this.activeModals.push(modal);
		this.modalStack.push(pageName);

		this.activePage = pageName;

		// Generate route name from pageName
		const routeName = this.generateRouteName(pageName);
		this.router.navigate([`/${routeName}`], { relativeTo: this.activateRouter });

		return await modal.present();
	}

	private generateRouteName(pageName: string): string {
		// Remove common suffixes if present
		const suffixes = ['Component', 'Page', 'Modal'];
		let baseName = pageName;
		for (const suffix of suffixes) {
			if (baseName.endsWith(suffix)) {
				baseName = baseName.slice(0, -suffix.length);
				break;
			}
		}
		return baseName.toLowerCase();
	}

	private getOptions(options: NavigationOptions) {
		let ModalOptions: NavigationOptions = {};
		if (typeof options === "undefined") {
			return ModalOptions = {
				multipleModals: false,
				backdropDismiss: false,
				customModalClass: 'custom-modal-class',
				callback: null
			}
		}

		ModalOptions.multipleModals = (typeof options.multipleModals === "undefined") ? false : options.multipleModals;
		ModalOptions.backdropDismiss = (typeof options.backdropDismiss === "undefined") ? false : options.backdropDismiss;
		ModalOptions.customModalClass = (typeof options.customModalClass === "undefined") ? 'custom-modal-class' : options.customModalClass;
		ModalOptions.callback = (typeof options.callback === "undefined") ? null : options.callback;
		return ModalOptions;
	}

	readDeviceOrientation() {
		if (Math.abs(window.orientation) === 90) {
			// Landscape
			return "portrait-landscape";
		} else {
			// Portrait
			return "portrait-primary";
		}
	}

	async openPopover(
		popoverName: string = '',
		data: any = {},
		popoverStyle: string = '',
		backdropDismiss: boolean = true,
		animated: boolean = true,
		showBackdrop: boolean = true,
		closeTimer: number = -1,
		size: PopoverSize = 'cover', // by default ion-popver uses 'auto', but auto' is not good for here,
		onDefaultCenter: boolean = true
	) {
		if (!popoverName) {
			console.log(`popover name cannot be blank -- ${popoverName}`);
			return;
		}

		this.isMobileApp = this.platform.is('capacitor');
		const popoverPage = PopoverClass(popoverName);

		if ((this.platform.is("capacitor") || this.platform.is("mobileweb")) && popoverName == "PopoverReconfirmation") {
			popoverStyle += " reconfirmation-mobile";
		}
		if (this.platform.is('ipad') && (popoverName == "VipTermsComponent" || popoverName == "PopoverAlertComponent")) {
			popoverStyle += " content-vipterm";
			popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " content-vipterm-ipad-web-portait" : " content-vipterm-ipad-web-landscape";
		} else {
			if (this.isMobileApp || this.platform.is('android') || this.platform.is('ios') || this.platform.is('ipad')) {
				if (onDefaultCenter) {
					if (this.platform.is('ipad') && (popoverStyle.includes("game-history-details") || popoverStyle.includes("self-exclude"))) {
						popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " game-history-details-and-self-exclude-portait" : " game-history-details-and-self-exclude-landscape";
					} else if (this.isMobileApp) {
						if (popoverStyle.includes("self-exclude") || popoverStyle.includes("SessionStats") || popoverStyle.includes("livedealer")) {
							popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " center-popover-from-portait-app" : " center-popover-from-landscape-app center-popover-from-landscape-app-wider";
						} else {
							popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " center-popover-from-portait-app" : " center-popover-from-landscape-app";
						}
					} else {
						if (!this.platform.is('ios')) {
							popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " center-popover-from-portait-app" : " center-popover-from-landscape-app";
						} else {
							popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " center-popover-from-portait-web" : " center-popover-from-landscape-web";
						}
					}
				}
			}
		}

		if (!popoverPage) {
			return;
		}

		return await this.popoverController
			.create({
				component: popoverPage,
				componentProps: { data },
				animated,
				showBackdrop,
				backdropDismiss,
				cssClass: popoverStyle,
				size,
			}).then(popover => {
				this.activePopovers.push(popover);
				popover.present();
				if (closeTimer > 0) {
					setTimeout(() => {
						popover.dismiss();
					}, closeTimer)
				}
				return popover;
			});
	}

	public dismiss(keywordRoute?) {
		this.modalStack.pop();
		const modal = this.activeModals.pop();
		modal?.dismiss({
			dismissed: true,
		});
		this.modalCtrl.dismiss();
		if (this.getActiveLobbyTab() == 'c' || this.getActiveLobbyTab() == 'game') {
			this.router.navigate([this.getActiveLobbyTab(), this.storeWPLinkCode])
		} else if (this.getActiveLobbyTab() == 'casino') {
			if (keywordRoute || this.getSelectedCasinoKeyword()) return this.router.navigate([this.getActiveLobbyTab(), keywordRoute ? keywordRoute : this.getSelectedCasinoKeyword()])
			return this.router.navigate([this.getActiveLobbyTab()])
		} else {
			this.toTab(this.getActiveLobbyTab())
		}
		return this.activeModals.length > 0;
	}

	public dismissAll(keywordRoute?) {
		this.activeModals.forEach(modal => {
			modal.dismiss();
		});

		while (this.activePopovers.length > 0) {
			const popover = this.activePopovers.pop();
			popover.dismiss();
		}

		this.activeModals = [];
		this.activePopovers = [];
		this.modalStack = [];

		const popoverController = this.popoverController;
		popoverController.getTop()
			.then(popover => {
				if (popover) {
					popoverController.dismiss();
				}
			});

		const alertController = this.alertController;
		alertController.getTop()
			.then(alert => {
				if (alert) {
					alertController.dismiss();
				}
			});
		if (this.getActiveLobbyTab() == 'c' || this.getActiveLobbyTab() == 'game') {
			this.router.navigate([this.getActiveLobbyTab(), this.storeWPLinkCode])
		} else if (this.getActiveLobbyTab() == 'casino' || this.getActiveLobbyTab() == 'casino/valley-forge') {
			if (keywordRoute || this.getSelectedCasinoKeyword()) return this.router.navigate([this.getActiveLobbyTab(), keywordRoute ? keywordRoute : this.getSelectedCasinoKeyword()])
			return this.router.navigate([this.getActiveLobbyTab()])
		} else {
			this.toTab(this.getActiveLobbyTab())
		}
		return;
	}

	public back() {
		if (this.activeModals.length) {
			this.closeActiveModal();
		} else {
			this.modalCtrl.dismiss();
			this.router.navigateByUrl("/");
			this.menuController.open('menu');
		}
	}

	private closeActiveModal() {
		const modal = this.activeModals[this.activeModals.length - 1];
		modal.dismiss();
		this.activeModals.pop();
		this.modalStack.pop();
		this.location.back();
		if (!this.activeModals.length) {
			this.menuController.open('menu');
		}
	}

	public getActivePage() {
		return this.activePage;
	}

	public pushHistoryState(pathname) {
		const newurl = window.location.protocol + "//" + window.location.host + '/' + pathname + window.location.search + document.location.hash;
		history.pushState({ path: newurl }, '', newurl);
		this.events.publish("event:history:push", { url: newurl });
	}

	public toTab(tabname: string, dismissModals?: boolean, wpLink?: string) {
		const tabname_lc = tabname?.toLowerCase();

		this.setActiveLobbyTab(tabname_lc)

		if (dismissModals) this.dismissAll(); //to close all modals before navigating to the tab.

		if (wpLink && tabname_lc == 'c') this.storeWPLinkCode = wpLink;
		if (tabname_lc == 'c') return this.router.navigate([tabname_lc, wpLink]).then(() => this.sendHistoryEvent(tabname_lc));
		if (tabname_lc == 'game') return this.router.navigate([tabname_lc, wpLink]).then(() => this.sendHistoryEvent(tabname_lc))

		//Casino Keyword Lobby Logic to include in Route
		if (tabname_lc == 'casino' && wpLink) return this.router.navigate([tabname_lc, wpLink]).then(() => this.sendHistoryEvent(tabname_lc));

		return this.router.navigate([tabname_lc]).then(() => this.sendHistoryEvent(tabname_lc));
	}

	//Include optional WPPage link params to accomodate new route changes
	public toWebview(dismissModals?: boolean, wpLink?: string) {
		return this.toTab('c', dismissModals, wpLink);
	}

	public toCasino(dismissModals?: boolean) {
		return this.toTab('casino', dismissModals);
	}

	public navigateToCasinoFromLogoClick(){
		this.events.publish('tab:default:casino');
		this.toTab('casino', false);
	}

	public toLanding(dismissModals?: boolean) {
		return this.toTab('landing', dismissModals);
	}

	public toSports(dismissModals?: boolean) {
		return this.toTab('sports', dismissModals);
	}

	public toLiveDealer(dismissModals?: boolean) {
		return this.toTab('live-dealer', dismissModals);
	}

	public toGametab(dismissModals?: boolean) {
		return this.toTab('launcher', dismissModals);
	}

	public toPromotions(dismissModals?: boolean) {
		return this.toTab('promotions', dismissModals);
	}

	public toHomePage(dismissModals?: boolean) {
		//define pathname for the home page if we want to display URL for the HomePage and that should mat
		/*this.events.publish("event:reload:externallinks");
		this.events.publish("event:load:home");
		const pageName = this.config.getExternalLinks().payload.filter(link => link?.code == "homepage")[0]?.url;*/

		return this.toTab('casino', dismissModals);
	}

	//Include optional WPPage link params to accomodate new route changes
	public toGameInfoTab(dismissModals?: boolean, wpLink?: string) {
		return this.toTab('game', dismissModals, wpLink);
	}

	private sendHistoryEvent(componentPath) {
		this.events.publish("event:history:push", { page: componentPath })
	}

	public toLobby() {
		return this.toCasino(true);
	}

	isOnLobby() {
		// let noNavigation = (!this.modalStack.length && this.navCtrl.length() === 1) ? true : false;
		let noNavigation = this.modalStack.length == 0;
		let menuIsOpen = true;
		if (!this.menuCtrl.hasOwnProperty("isOpen")) {
			if (this.menuCtrl.isOpen()) {
				menuIsOpen = false;
			}
		}
		return !(noNavigation && menuIsOpen) ? true : false;
	}
	public onReloadApp() {
		const origin: string = window.location.origin;
		window.location.href = origin;
		return setTimeout(() => window.location.reload(), 100);
	}

	public goBackOrExitApp() {
		if (this.activeModals && this.activeModals.length > 0) {
			this.closeActiveModal();
		} else {
			navigator['app'].exitApp();
		}
	}

	public checkModalDuplication(page: string): boolean {
		return this.modalStack.includes(page);
	}

	public setActiveLobbyTab(tabname) {
		this.activeLobbyTabName = tabname;
	}

	public getActiveLobbyTab() {
		return this.activeLobbyTabName;
	}

	setSelectedCasinoKeyword(casinoKeywordName) {
		this.storeCasinoKeywordRoute = casinoKeywordName;
	}

	getSelectedCasinoKeyword() {
		return this.storeCasinoKeywordRoute;
	}
}
